export default {
  GET_ALL_DATAS: (state) => state.datas,
};
